import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalPlayComponent } from '../modal-play/modal-play.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-how-it-works',
    imports: [TranslateModule],
    templateUrl: './how-it-works.component.html',
    styleUrl: './how-it-works.component.scss'
})
export class HowItWorksComponent {
  constructor(public modal: MatDialog) {}
  playModalPlay(): void {
    const dialogRef = this.modal.open(ModalPlayComponent, {
      data: {
        videoUrl:
          'https://storage.googleapis.com/weayr-assets-non-prod/videos/AYR_OLD_VIDEO.mp4',
      },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
}
